import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CoObjectItem } from "../../../components/interfaces/CoObject";
import { Tag } from "../../../components/interfaces/Tag";
import { Rule } from "../../../components/interfaces/Rule";

export interface ValidationState {
  coObjects: CoObjectItem[];
  tags: Tag[];
  rules: Rule[];
  isLoading: boolean;
  isLoaded: boolean;
}

const initialState: ValidationState = {
  coObjects: [],
  tags: [],
  rules: [],
  isLoading: false,
  isLoaded: false,
};

const validationSlice = createSlice({
  name: "validation",
  initialState,
  reducers: {
    setValidationData(
      state,
      action: PayloadAction<{ coObjects: CoObjectItem[]; tags: Tag[]; rules: Rule[] }>
    ) {
      state.coObjects = action.payload.coObjects;
      state.tags = action.payload.tags;
      state.rules = action.payload.rules;
      state.isLoading = false;
      state.isLoaded = true;
    },
    setTags(state, action: PayloadAction<Tag[]>) {
      state.tags = action.payload;
    },
    setRules(state, action: PayloadAction<Rule[]>) {
      state.rules = action.payload;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    invalidate(state) {
      state.isLoaded = false;
    },
  },
});

export const { setValidationData, setTags, setRules, setIsLoading, invalidate } =
  validationSlice.actions;

export const selectValidationState = (state: { validation: ValidationState }) => state.validation;
export const selectValidationTags = (state: { validation: ValidationState }) =>
  state.validation.tags;
export const selectValidationRules = (state: { validation: ValidationState }) =>
  state.validation.rules;
export const selectValidationCoObjects = (state: { validation: ValidationState }) =>
  state.validation.coObjects;
export const selectValidationIsLoading = (state: { validation: ValidationState }) =>
  state.validation.isLoading;
export const selectValidationIsLoaded = (state: { validation: ValidationState }) =>
  state.validation.isLoaded;

export default validationSlice.reducer;
